import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { ReadOnlyTableRow } from 'components/BusinessToolForm/Sections/FinancialPlan/components/TableComponents/ReadOnlyTableRow';
import { TableSectionTitle } from 'components/BusinessToolForm/Sections/FinancialPlan/components/TableComponents/TableSectionTitle';
import { getEachRowValues } from 'components/BusinessToolForm/Sections/FinancialPlan/ProfitAndLossProjection/components/FormSections/NetSalesForm/helpers';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { ADJUSTMENTS_FOR_NAMES, useGetAdjustmentsForLinkedFields } from './utils/form';
import { adjustmentsForPrefix, FIRST_COLUMN_WIDTH } from '../../../../utils/form';

export const AdjustmentsForForm: FC = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();
  const { isExamplePage} = useExamplePreview()
  const adjustmentsForLinkedFields = useGetAdjustmentsForLinkedFields(isExamplePage);

  const period = useWatch({ name: GLOBAL_PERIOD_NAME });

  const [deprecation, assetsSale, deferredTax] = getValues([
    concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION),
    concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES),
    concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES),
  ]);

  return (
    <Grid container direction={'column'}>
      <Grid item xs>
        <TableSectionTitle title={t('financialPlan.projectedCashFlow.inDirect.adjustmentsFor.title')} />
      </Grid>
      <Grid item xs>
        <ReadOnlyTableRow
          name={concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION)}
          columnValues={getEachRowValues([deprecation], 0, period)}
          firstColumnWidth={FIRST_COLUMN_WIDTH}
          rowTitle={adjustmentsForLinkedFields[ADJUSTMENTS_FOR_NAMES.DEPRECIATION_AMORTIZATION].title}
          noNeedName={true}
        />
      </Grid>
      <Grid item xs>
        <ReadOnlyTableRow
          name={concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES)}
          columnValues={getEachRowValues([assetsSale], 0, period)}
          firstColumnWidth={FIRST_COLUMN_WIDTH}
          rowTitle={adjustmentsForLinkedFields[ADJUSTMENTS_FOR_NAMES.GAIN_LOSSES_ASSET_SALES].title}
          noNeedName={true}
        />
      </Grid>
      <Grid item xs>
        <ReadOnlyTableRow
          name={concatWithDot(adjustmentsForPrefix, ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES)}
          columnValues={getEachRowValues([deferredTax], 0, period, true)}
          firstColumnWidth={FIRST_COLUMN_WIDTH}
          rowTitle={adjustmentsForLinkedFields[ADJUSTMENTS_FOR_NAMES.CHANGES_DEFERRED_TAXES].title}
          noNeedName={true}
        />
      </Grid>
    </Grid>
  );
};
